module.exports = __webpack_public_path__ + "static/logo-5d4bc3559e895f733a2f9e1f35c19078.svg";